import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
  },
  grid: {
    height: '100%',
    textAlign: 'center',
  },
  gridItem: {
    height: '80vh',
    width: '100%',
  },
}));

export default useStyles;
